import {inject, Injectable} from '@angular/core';
import {BaseApiService} from './base-api.service';
import {IItem} from '../../types/IItem';
import {AppStore} from '../store/app.store';

@Injectable({providedIn: 'root'})
export class CartItemService extends BaseApiService {
  private appStore = inject(AppStore);

  sync(items: {item: IItem, grade: 'good' | 'better' | 'best'}[]): void {
    const clientId = this.appStore.client_id();
    const cartId = this.appStore.cart().id;

    const payload = {
      items: items.map(({item, grade}) => ({
        item_id: item.id,
        brand: item.brand,
        group: item.model,
        part_number: item.item_number,
        rawsize: item.size.replace(/[^\d|]/g, ''),
        quantity: item.sourcing.reduce((sum, s) => sum + s.selected_quantity, 0),
        grade,
        suppliers: item.availability.map(a => {
          const sourced = item.sourcing.find(s => s.id === a.id && s.name === a.name && s.vendor?.id === a.vendor?.id);
          return {
            vendor_type: a.type,
            vendor_id: a.type === 'distributor' ? a.vendor.id : null,
            available_quantity: a.quantity,
            selected_order_quantity: sourced?.selected_quantity ?? null,
            cost_cents_each: Math.round(a.cost * 100),
            fet_cents_each: item.fet ? Math.round(item.fet * 100) : null,
            price_cents_each: sourced ? Math.round(sourced.price * 100) : null,
            estimated_delivery_date: a.estimated_delivery_date ?? null,
            branch: a.name,
          };
        }).filter(a => a.vendor_type === 'local' ? a.selected_order_quantity : true),
      })),
    };

    this.post(`clients/${clientId}/carts/${cartId}/items/bulk`, payload).subscribe();
  }

  clear(): void {
    const clientId = this.appStore.client_id();
    const cartId = this.appStore.cart().id;
    this.delete(`clients/${clientId}/carts/${cartId}/items/clear`).subscribe();
  }

  destroy(itemId: number): void {
    const clientId = this.appStore.client_id();
    const cartId = this.appStore.cart().id;
    this.delete(`clients/${clientId}/carts/${cartId}/items/delete-by-item?item_id=${itemId}`).subscribe();
  }
}
